module.exports = require("webfontloader");